// extracted by mini-css-extract-plugin
module.exports = {"release":"musicmediaembed-module--release--29ICU","embed":"musicmediaembed-module--embed--2gdBj"};